// extracted by mini-css-extract-plugin
export default {"editButton":"fixedDeduction_editButton__pIy27","TableBody":"fixedDeduction_TableBody__WQ2Kt","deleteButton":"fixedDeduction_deleteButton__mOswr"};